<template>
  <main-layout wide>
    <collateral-folder-menu-container />
  </main-layout>
</template>
<script>

import CollateralFolderMenuContainer from '@/components/Widgets/Collateral/CollateralFolderMenuContainer';

export default {
  name: 'CollateralIndex',
  components: {
    CollateralFolderMenuContainer,
  },
};
</script>
